// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"8c4b461e","453":"ee87fd06","877":"d44c3626"}[chunkId] + ".chunk.js";
};